<template>
  <v-row>
    <v-col class="px-0">
      <v-card outlined>
        <v-card-title class="clickable" @click="switchCard()">
          <v-row class="no-gutters justify-space-between">
            <v-col class="col-auto">
              {{ $t('stornoHistory.exportCancellations') }}
            </v-col>
            <v-col class="col-auto">
              <v-btn icon>
                <span v-if="cardOpen" class="fal fa-chevron-up fa-2x" />
                <span v-else class="fal fa-chevron-down fa-2x" />
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-expand-transition>
          <v-card-text v-if="cardOpen">
            <v-row>
              <v-col class="col-12 pb-0">
                <booking-date-picker @selected="dateRangeChanged" />
              </v-col>
              <!-- download excel button -->
              <v-col class="col-12 text-center pt-0">
                <v-btn
                  color="primary"
                  large
                  outlined
                  @click="downloadCancellationExcel"
                >
                  <i class="fad fa-file-spreadsheet mr-2" />
                  {{ $t('stornoHistory.excelDownload') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-expand-transition>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import XLSX from 'xlsx'
import XlsxHelper from '@/classes-shared/XLSX/XlsxHelper'
import Cancellations from '@/classes-shared/cancellation/Cancellations'
import BookingDatePicker from '@/components-internal/booking/BookingDatePicker'
import store from '@/store/store'

export default {
  name: 'StornoExport',

  components: {
    BookingDatePicker,
  },

  data() {
    return {
      dateRange: null,
      dateFormatApi: 'YYYY-MM-DDTHH:mm:ss',
      dateFormatExcel: 'DD.MM.YYYY',
      cardOpen: false,
    }
  },

  methods: {
    dateRangeChanged(dateRange) {
      this.dateRange = dateRange
    },
    async downloadCancellationExcel() {
      EventBus.$emit('spinnerShow')
      let workBook = XLSX.utils.book_new()
      const cancellations = await this.getSortedCancellationsForExport()
      if (cancellations.getCancellations().length > 0) {
        const workSheet = await this.getCancellationWorkSheet(cancellations)
        await XLSX.utils.book_append_sheet(
          workBook,
          workSheet,
          this.$t('stornoHistory.cancellations')
        )
        EventBus.$emit('spinnerHide')
        XLSX.writeFile(
          workBook,
          this.$t('stornoHistory.cancellations') + '.xlsx'
        )
      } else {
        EventBus.$emit('spinnerHide')
        EventBus.$emit('notify', i18n.t('stornoHistory.noData'))
      }
    },
    async getCancellationWorkSheet(cancellations) {
      let jsonWorksheet = []
      cancellations.getCancellations().forEach((cancellation) => {
        cancellation.getBookingEntries().forEach((bookingEntry) => {
          jsonWorksheet.push({
            id: cancellation.getId(),
            customerId: bookingEntry.getUser().getId(),
            customerFirstName: bookingEntry.getUser().getFirstName(),
            customerLastName: bookingEntry.getUser().getLastName(),
            customerMail: bookingEntry.getUser().getMail(),
            productName: bookingEntry.getProductDefinitionTranslation(),
            startDate: this.$options.filters.formatDate(
              bookingEntry.getStartDate(),
              this.dateFormatExcel
            ),
            endDate: this.$options.filters.formatDate(
              bookingEntry.getEndDate(),
              this.dateFormatExcel
            ),
            currency: store.getters
              .getCurrentDestinationInstance()
              .getCurrency(),
            priceNet: bookingEntry.getPrice() / 100,
            priceGross: bookingEntry.getPriceGross() / 100,
            promoCode: bookingEntry.getPromoCode(),
            promoCodeReduction: bookingEntry.getPromoReduction() / 100,
            reason: cancellation.getReason(),
            userFirstName: cancellation.getUser().getFirstName(),
            userLastName: cancellation.getUser().getLastName(),
          })
        })
      })
      let workSheet = XLSX.utils.json_to_sheet(jsonWorksheet)
      let xlsxHelper = new XlsxHelper(workSheet)
      await xlsxHelper.setHeader([
        this.$t('stornoHistory.cancellationId'),
        this.$t('stornoHistory.customerId'),
        this.$t('stornoHistory.customerFirstName'),
        this.$t('stornoHistory.customerLastName'),
        this.$t('stornoHistory.customerMail'),
        this.$t('stornoHistory.productName'),
        this.$t('stornoHistory.startDate'),
        this.$t('stornoHistory.endDate'),
        this.$t('stornoHistory.currency'),
        this.$t('stornoHistory.priceNet'),
        this.$t('stornoHistory.priceGross'),
        this.$t('stornoHistory.promoCode'),
        this.$t('stornoHistory.promoReduction'),
        this.$t('stornoHistory.reason'),
        this.$t('stornoHistory.employeeFirstName'),
        this.$t('stornoHistory.employeeLastName'),
      ])

      // set auto width
      await xlsxHelper.setColumnWidthAuto()
      return xlsxHelper.getWorkSheet()
    },
    async getSortedCancellationsForExport() {
      const cancellations = new Cancellations(this.$store)
      await cancellations.loadCancellationsForExport(
        this.$options.filters.formatDate(
          this.dateRange.from,
          this.dateFormatApi
        ),
        this.$options.filters.formatDate(this.dateRange.to, this.dateFormatApi)
      )
      return cancellations
    },
    switchCard() {
      this.cardOpen = !this.cardOpen
    },
  },
}
</script>
